import useWindowWidthCheck from '@anm/hooks/useWindowWidthCheck';
import { SHOW_MOBILE_HEADER_BREAKPOINT } from '@anm/styles/constants';
import { FC } from 'react';

import { ButtonsWrapper, NavButtonVariant } from '../Wrapper';
import { ListElement } from '../types';

import DesktopButtons from './Desktop';
import DropdownButtons from './Dropdown';

export type ButtonProps = {
  list: ListElement[];
  activeButton: number;
  onActiveButtonChange: (index: number) => void;
  onActionSheetOpen?(): void;
  navButtonVariant?: NavButtonVariant;
  showNavigationDropdownBreakpoint?: number;
};

const Buttons: FC<ButtonProps> = ({ onActionSheetOpen, onActiveButtonChange, ...otherProps }) => {
  const showDropdown = useWindowWidthCheck(
    otherProps.showNavigationDropdownBreakpoint! || SHOW_MOBILE_HEADER_BREAKPOINT
  );

  return (
    <ButtonsWrapper {...otherProps}>
      {showDropdown ? (
        <DropdownButtons {...otherProps} onActionSheetOpen={onActionSheetOpen} />
      ) : (
        <DesktopButtons {...otherProps} onActiveButtonChange={onActiveButtonChange} />
      )}
    </ButtonsWrapper>
  );
};

export default Buttons;
